import type React from 'react';
import type { CatalogImportRecord } from '@/api/models';
import { LabelsCardView } from './LabelsCardView';
import { labelsCardOf } from './labelsCardMeta';
import { useLabelListDownload } from './useLabelListDownload';

type LabelsCardProps = {
    record: CatalogImportRecord;
};

/**
 * The labels to print after an import that generated barcodes (bos-app#232,
 * AC-07): the card and its `.xlsx` download, from the record's
 * `generatedBarcodes`. Renders nothing when the import generated none. It
 * serves its own download, so the Result step only hands it the record.
 */
export const LabelsCard: React.FC<LabelsCardProps> = ({ record }) => {
    const labels = labelsCardOf(record);
    const download = useLabelListDownload(
        record.generatedBarcodes,
        record.createdAt,
    );

    return labels === null ? null : (
        <LabelsCardView download={download} labels={labels} />
    );
};
